import createListActions from "src/app/redux/utils/createListActions";
import entityHistoryRest from './rest';
import { createClearEntityErrorAction } from "src/app/redux/utils/createClearEntityErrorAction";

export default {
  clearError: createClearEntityErrorAction('ENTITY_HISTORY'),
  fetchEntityHistoryList: createListActions('ENTITY_HISTORY', entityHistoryRest.fetchEntityHistoryList),
  fetchEntityHistoryListBySession: createListActions('ENTITY_HISTORY_LIST_BY_SESSION', entityHistoryRest.fetchEntityHistoryBySessionList),
};
